import React, { useEffect, useState } from 'react';
import { Text, Button, Row, FlexView, Col, Separator } from '@cuemath/comps';
import { COLORS } from '@cuemath/comps';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Message } from 'modules/form';
import { Input, Asterisk, Label, SelectInput } from 'modules/form';
import { closeModal } from 'actions/modal';
import { useChangeParentPatch } from 'actions/change-crm-parent';
import { COUNTRY_OPTIONS } from 'utils';

const Wrapper = styled.div`
  padding: 40px 10px 20px;
`;

export const SelectInputWrapper = styled(SelectInput)`
  width: 140px;
  height: 40px;
  padding: 5px 10px;
  outline: none;
  display: inline-block;
  &:focus {
    border: 3px solid #c4dffe;
    &::placeholder {
      opacity: 0;
    }
  }
`;

let timeout = null;

const ChangeCrmParent = ({ student }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ phone: '', countryCode: '91' });
  const { phone: parentPhone, countryCode } = form || {};
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { student_id: studentId } = student || {};

  useEffect(() => {
    return () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  });

  const onChangeParentPatchComplete = (errorMsg, data) => {
    const { parent_id: parentId } = data || {};

    if (parentId) {
      setSuccess('Parent changed successfully.');
      timeout = setTimeout(() => dispatch(closeModal()), 2000);
    } else {
      setError(errorMsg || 'something went wrong');
    }
  };

  const { patch: changeParentPatch, isProcessing } = useChangeParentPatch({
    onComplete: onChangeParentPatchComplete,
  });

  const changeExtension = selectedCountry => {
    setForm(prev => ({ ...prev, countryCode: selectedCountry.value }));
  };

  const onChange = value => {
    if (value.length > 13) return;
    setForm(prev => ({ ...prev, phone: value }));
  };

  const onConfirm = () => {
    setError('');
    const payload = {
      phone: parentPhone,
      country_code: countryCode,
      action: 'CHANGE_PARENT',
    };

    changeParentPatch(studentId, payload);
  };

  const isDisabled = isProcessing || !parentPhone;

  return (
    <Wrapper>
      <Text color={COLORS.BLACK} size="large" weight="bolder" align="center">
        Assign New Parent to Student
      </Text>
      <Separator height={16} transparent />
      <Row alignItems="center">
        <Col>
          <Label style={{ width: '200px' }}>
            {'Phone Number'}
            <Asterisk>*</Asterisk>
          </Label>
        </Col>
        <SelectInputWrapper
          defaultValue={{
            label: `india-91`,
            value: '91',
            countryName: 'india',
          }}
          name="countryCode"
          onChange={changeExtension}
          options={COUNTRY_OPTIONS}
        />
        <Row alignItems="center">
          <Input
            style={{ width: '240px' }}
            name={'phone'}
            placeholder={'Enter the Phone No.'}
            type="number"
            required={true}
            value={form.phone}
            onChange={onChange}
          />
        </Row>
      </Row>
      <Separator height={16} transparent />
      <FlexView flexDirection="row" justifyContent="center" alignItems="center">
        {success ? (
          <Message width="100%">{success}</Message>
        ) : (
          <Button
            align="center"
            label="Submit"
            onClick={onConfirm}
            disabled={isDisabled}
          />
        )}
      </FlexView>
      {error && (
        <Message width="100%" error>
          {error}
        </Message>
      )}
      <Separator height={40} transparent />
      <Text color={COLORS.BLACK} size="small" weight="bolder" align="left">
        Note: This function relates to modifying the parent entity within the CRM system.
      </Text>
    </Wrapper>
  );
};

export default ChangeCrmParent;
